export function joinUrl(base: string, ...parts: string[]) {
  let url = base
  for (const part of parts) {
    const leading = part.startsWith("/")
    const trailing = base.endsWith("/")

    if (leading && trailing) {
      url += `${part.slice(1)}`
    } else if (leading || trailing) {
      url += `${part}`
    } else {
      url += `/${part}`
    }
  }

  return url
}
